module.exports = "/_next/static/images/icon4-b51a200e536dba785adf0e7030590d9c.png";